export const env = {
  API_BASE_URL: import.meta.env.VITE_API_URL || 'http://localhost:5055',
  AZURE_CLIENT_ID: import.meta.env.VITE_AZURE_CLIENT_ID || '5ce32a5c-c14a-400b-9550-880b2fe65069',
  AZURE_TENANT_ID: import.meta.env.VITE_AZURE_TENANT_ID || 'eedd1340-df1a-4db2-8a03-b4cfb1fa3e9d',
};
